export class LocalStorage {
  public static EDIT_LINK = 'editLink';
  public static readonly CURRENT_SITE = 'currentSite';
  public static readonly CURRENT_FOLDER = 'currentFolder';
  public static readonly RESOLVE_COMMENTS = 'resolveComments';
  public static readonly IS_ALL_COMMENT_DELETED = 'isAllCommentDeleted';
  public static readonly BASE_HREF_PATH_URL = 'baseHrefPathUrl';
  public static readonly CURRENT_SITE_DATA = 'currentSiteData';
  public static readonly KEYWORD_ID_SELECT_FOR_CHEVRON =
    'keywordIdSelectForChevron';
  public static readonly BASE_HREF_FOR_LINK_PLUGIN = 'baseHrefForLinkPlugin';
  /**
   *  this list is used only on editor component on Destroy
   */
  public static clearStorageOnEditorDestroy = [
    'editLink',
    'baseHrefId',
    'trackchangesandcommentsdata',
    'baseHrefPathUrl',
    'subTemplateList',
    'dataUnlockSection',
    'toggleTemplateDocHoverUI',
    'currentFocusedId',
    'isToolTipFeatureRequired',
    'createdCommentThreadId',
    'baseHrefForLinkPlugin',
    'isLiTagUpForSubTempInsertion',
    'citationsDataReady',
    'keywordIdSelectForChevron',
  ];
  public static REMOVE_MARKER_FROM_LINK = 'removeMarkerLink';
  public static RHP_CITATION_REF_CLICKED = 'rhpCitationRefClicked';
  public static CURRENT_LHP_SCROLLED_ID = 'currentScrolledId';
  public static LINK_TO_FRAGMENT_AVAILABLE = 'linkToFragmentAvailable';
  public static CURRENT_USER = 'currentUser';
  public static RHP_TRACK_CHANGES_ENABLE_DISABLE_LISTENER =
    'isRHPTrackChangesEnabled';
  public static readonly EXTERNAL_PASTE_SKIP_WARNING =
    'wkExternalPasteSkipWarning';
}
